import Layout from "@/components/Layout";
import { RESTAURANT, VENICE_CANAL } from "@/lib/constants";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function ContattiPage() {
  return (
    <Layout>
      <section className="border-b border-ink">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-16 md:pt-24 pb-12 md:pb-20">
          <div className="overline mb-6">Capitolo IV — Contatti</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">
            Veniteci <em className="text-wine">a trovare.</em>
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-14">
          {/* Info column */}
          <div className="lg:col-span-5 flex flex-col gap-10">
            <ContactBlock icon={<MapPin size={18} />} label="Indirizzo" value={RESTAURANT.address} testid="contact-address" />
            <div className="hairline" />
            <ContactBlock icon={<Phone size={18} />} label="Telefono" value={RESTAURANT.phone} testid="contact-phone" />
            <div className="hairline" />
            <ContactBlock icon={<Mail size={18} />} label="Email" value={RESTAURANT.email} testid="contact-email" />
            <div className="hairline" />
            <div data-testid="contact-hours">
              <div className="flex items-center gap-3 overline mb-3">
                <Clock size={16} /> Orari
              </div>
              <ul className="font-serif text-lg space-y-2">
                {RESTAURANT.hours.map((h) => (
                  <li key={h.day} className="flex justify-between gap-6">
                    <span>{h.day}</span>
                    <span className="font-mono text-sm text-ink-mid">{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Image / placeholder map */}
          <div className="lg:col-span-7">
            <div className="aspect-[4/3] border border-ink overflow-hidden relative">
              <img src={VENICE_CANAL} alt="Venezia" className="w-full h-full object-cover duotone" />
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="bg-paper/95 border border-ink px-8 py-6 text-center">
                  <div className="overline mb-2">Trovaci nel cuore di</div>
                  <div className="font-serif text-3xl md:text-4xl">Venezia</div>
                  <div className="font-mono text-xs tracking-widest mt-2 text-ink-mid">
                    {RESTAURANT.address}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

function ContactBlock({ icon, label, value, testid }) {
  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-3 overline mb-3">{icon}{label}</div>
      <div className="font-serif text-2xl md:text-3xl">{value}</div>
    </div>
  );
}
